(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningPathForm", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningPaths/add/learningPathFormView.html",
            controller: ["learningPathResource", "frameworkService", "messageService", "$translate", "$q", "$filter", "$localStorage", LearningPathFormCtrl],
            controllerAs: "vm"
        };
        function LearningPathFormCtrl(learningPathResource, frameworkService, messageService, $translate, $q, $filter, $localStorage) {
            var vm = this;
            vm.model = {
                requalifyDays: 30,
                sendExpiringNotification: true,
                expiringNotificationInterval: 5
            };
            vm.tenantUrl = $localStorage.tenantSettings.url + "." + $localStorage.tenantSettings.domain;
            vm.showConfirmation = false;
            vm.showErrors = false;
            vm.saving = false;
            vm.storefrontEnabled = frameworkService.data.tenantFeatures.storefront;
            //EXAMPLE $translate.onReady()
            $translate.onReady().then(function () {
                vm.ready = true;
            });
            vm.checkNameIsAvailable = function (name) {
                return $q(function (resolve, reject) {
                    learningPathResource.getIsNameAvailable({ name: name }, function (result) {
                        if (result.value)
                            resolve(true);
                        else
                            reject();
                    });
                });
            };
            vm.updateFriendlyUrl = function () {
                vm.model.friendlyUrl = $filter("slugify")(vm.model.name);
            };
            vm.save = function () {
                if (vm.form.$valid) {
                    vm.saving = true;
                    learningPathResource.save(vm.model, function (result) {
                        vm.showConfirmation = true;
                        vm.learningPath = result;
                    }, function () {
                        vm.saving = false;
                        messageService.error("common.genericError");
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
        }
    });
}());
